import Vue from 'vue'
import VueRouter from 'vue-router'
import Windows from '../views/WindowsView.vue'
import MacOs from'../views/MacOsView.vue'
import Register from'../views/Register.vue'
import MainLayout from "../layouts/MainLayout.vue";
import HomeView from "../views/Home.vue";
import DownloadView from "../views/Download.vue";
import FeaturesView from "../views/Features.vue";
import PricingView from "../views/Pricing.vue";
import FaqView from "../views/Faq.vue";
import Partners from "@/views/Partners.vue";
import TechCoop from "@/views/TechCoop.vue";
import Company from "@/views/Company.vue";
import Trial from "@/views/Trial.vue";
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: MainLayout,
    children: [
        { path: '', component: HomeView },
        { path: 'download', component: DownloadView },
        { path: 'download/app', component: DownloadView },
        { path: "features", component: FeaturesView },
        { path: "pricing", component: PricingView },
        { path: 'faq', component: FaqView },
        { path: 'partners', component: Partners },
        { path: 'tech-coop', component: TechCoop },
        { path: 'company', component: Company },
        { path: 'trial', component: Trial },
        { path: 'apply', component: Trial },
    ]
  },
  {
    path: '/Windows',

    component:Windows
  },
  {
    path: '/Register',

    component:Register
  },
  {
    path: '/MacOs',

    component:MacOs
  }
]

const router = new VueRouter({
  mode: process.env.ROUTE_MODE || 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
